import { Component } from '@angular/core';

@Component({
  selector: 'app-felpudo',
  imports: [],
  templateUrl: './felpudo.component.html',
  styleUrl: './felpudo.component.scss'
})
export class FelpudoComponent {

}
